<!--
 * @Author: your name
 * @Date: 2021-10-13 13:45:20
 * @LastEditTime: 2022-04-13 13:40:32
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\process-order\forward\index.vue
-->
<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STRATEGY_SOURCE_ROUTE_LIST"> </BjRouteTabs>
    <div style="width:400px" class="mt16">
      <el-link type="warning" :underline="false">{{ $t('SettingOrderSourceStrategySourcing.title') }}</el-link>
      <draggable
        v-model="list"
        ghost-class="ghost"
        chosen-class="chosen"
        force-fallback="true"
        group="people"
        animation="300"
        filter=".forbid"
        draggable=".item"
        class="mt16"
        handle=".svg-icon"
        @end="onEnd"
      >
        <div v-for="(item, index) in list" :key="index" class="item">
          <div>
            {{ $t('SettingOrderSourceStrategySourcing.'+item.code) }}
          </div>

          <div class="item-right">
            <el-switch
              v-model="item.status"
              :active-value="1"
              :inactive-value="0"
              class="switch"
              @change="onChange(item, index)"
            />
            <svg-icon icon-class="pointer"></svg-icon>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>
<script>
import { orderApi } from '@/api';
import draggable from 'vuedraggable';
import { STRATEGY_SOURCE_ROUTE_LIST } from '@/utils/constants';
const getDefaultForm = () => {
  return {};
};

export default {
  name: 'SettingOrderSourceStrategySourcing',
  components: {
    draggable,
  },
  data() {
    return {
      STRATEGY_SOURCE_ROUTE_LIST,
      // 表单参数
      form: getDefaultForm(),
      // 表单校验
      rules: {},

      list: [
        // { id: 1, name: '发货仓数少', check: true, code: 'SettingOrderSourceStrategySourcing.warehouseNum' },
        // { id: 2, name: '收发距离近', check: true, code: 'SettingOrderSourceStrategySourcing.distance' },
        // { id: 3, name: '运费成本低', check: true, code: 'SettingOrderSourceStrategySourcing.freightCost' },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.reFresh();
  },
  methods: {
    // 开始拖拽事件
    onEnd() {
      this.updateApi(
        this.list.map((e, index) => {
          return { ...e, sortNum: index + 1 };
        }),
      );
    },
    onChange(item, index) {
      this.updateApi([item]);
    },
    reFresh() {
      orderApi.getSouringStrategyConfigs().then(res => {
        if (res.content && Array.isArray(res.content)) {
          // 先按 sortNum 排序, 小的在优先、排前面
          const TEMP = [].concat(res.content).sort((a, b) => {
            return a.sortNum - b.sortNum;
          });
          this.list = TEMP.sort((a, b) => {
            return true; // b.status - a.status;
          });
        }
      });
    },
    updateApi(API_DATA) {
      orderApi.updateSouringStrategyConfigsBatch(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #fdfdfd;
  border: solid 1px #eee;
  margin-bottom: 10px;
  border-radius: 4px;
  .item-right {
    display: flex;
    align-items: center;
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.svg-icon {
  margin-left: 18px;
  font-size: 16px;
  cursor: move;
}
.el-link {
  cursor: auto;
}
</style>
